import { useRef, useEffect } from 'react';
import { RootState } from '../../store';
import { useReduxSelector } from '../../Store/reduxHooks';

const SearchField = (props: any) => {
  const isMapLoaded = useReduxSelector(
    (state: RootState) => state.Common.isMapLoaded
  );
  const { setMapCenter, setZoomLevel } = props;

  const placeAutocompleteContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isMapLoaded || !placeAutocompleteContainerRef.current) return;

    let widget: HTMLElement | null = null;
    let handleSelect: ((event: Event) => Promise<void>) | null = null;
    let active = true;

    const init = async () => {
      await google.maps.importLibrary('places');

      if (!active || !placeAutocompleteContainerRef.current) return;

      widget = document.createElement('gmp-place-autocomplete');

      widget.setAttribute('placeholder', 'Search for a location');

      placeAutocompleteContainerRef.current.innerHTML = '';
      placeAutocompleteContainerRef.current.appendChild(widget);

      handleSelect = async (rawEvent: Event) => {
        const event = rawEvent as any;
        const place = event.placePrediction?.toPlace?.();

        if (!place) return;

        await place.fetchFields({
          fields: ['displayName', 'formattedAddress', 'location']
        });

        const lat = place.location?.lat();
        const lng = place.location?.lng();

        if (lat !== undefined && lng !== undefined) {
          setMapCenter({ lat, lng });
          setZoomLevel(11);
        }
      };

      widget.addEventListener('gmp-select', handleSelect as EventListener);
    };

    init();

    return () => {
      active = false;

      if (widget && handleSelect) {
        widget.removeEventListener('gmp-select', handleSelect as EventListener);
      }

      if (placeAutocompleteContainerRef.current) {
        placeAutocompleteContainerRef.current.innerHTML = '';
      }
    };
  }, [isMapLoaded, setMapCenter, setZoomLevel]);

  return (
    <div className="map-search-box">
      <div className="map-search">
        <div
          ref={placeAutocompleteContainerRef}
          id="place-autocomplete-container"
        />
      </div>
    </div>
  );
};

export default SearchField;
